module.exports = __webpack_public_path__ + "static/media/providerGoldTop1M.2ca44f90.webp";